// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.tag-container {\r\n  /* variables */\r\n  --tag-count: 0;\r\n  /* behavior */\r\n  overflow-x: auto;\r\n  display: flex;\r\n  gap: 8px;\n}\n.tag-container::-webkit-scrollbar {\r\n  display: none;\n}\n.tag-container > * {\r\n  /* flex properties */\r\n  flex: 0 0 calc(100% / var(--tag-count));\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
